export const DOM_LOADED = "turbo:load";
